import { PlansListResponseDto } from '@tiendanube/common';
import {
  useShouldScheduleDowngrade,
  useUpdatePlan,
} from 'domains/Billing/BillingPlans/hooks';
import { trackingBillingDowngradeFreePlan } from 'domains/Billing/tracking';
import {
  DowngradeBasicPlanModal,
  DowngradePlanModal,
  UpgradePlanModal,
} from './components';
import { ChangeType } from '../../BillingPlansPage';

export interface ChangePlanModalProps {
  show: boolean;
  changeType?: ChangeType;
  onConfirm: () => void;
  onCancel: () => void;
  currentPlan?: PlansListResponseDto;
  newPlan?: PlansListResponseDto;
}

function ChangePlanModal(props: Readonly<ChangePlanModalProps>) {
  const { changeType, onConfirm, newPlan, currentPlan } = props;
  const { shouldScheduleDowngrade } = useShouldScheduleDowngrade();
  const { isLoading } = useUpdatePlan();

  const handleOnConfirm = () => {
    if (changeType === 'downgrade' || changeType === 'basic')
      trackingBillingDowngradeFreePlan({
        currentPlan: currentPlan?.name || '',
        newPlan: newPlan?.name || '',
        scheduled: shouldScheduleDowngrade,
      });
    onConfirm();
  };

  switch (changeType) {
    case 'upgrade':
      return (
        <UpgradePlanModal
          {...props}
          onConfirm={handleOnConfirm}
          disableConfirm={isLoading}
        />
      );
    case 'basic':
      return (
        <DowngradeBasicPlanModal
          {...props}
          onConfirm={handleOnConfirm}
          disableConfirm={isLoading}
        />
      );
    case 'downgrade':
      return (
        <DowngradePlanModal
          {...props}
          onConfirm={handleOnConfirm}
          disableConfirm={isLoading}
        />
      );
    default:
      return null;
  }
}

export default ChangePlanModal;
